import { useEffect, useState } from "react";

export function useNetworkStatus() {
  const [quality, setQuality] = useState("unknown");

  const updateConnectionStatus = () => {
    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    if (!connection) {
      setQuality("unknown");
      return;
    }

    const { effectiveType, downlink } = connection;

    if (effectiveType === "slow-2g" || effectiveType === "2g") {
      setQuality("poor");
    } else if (effectiveType === "3g") {
      setQuality("average");
    } else if (effectiveType === "4g") {
      if (downlink && downlink > 5) {
        setQuality("excellent");
      } else {
        setQuality("good");
      }
    }
  };

  useEffect(() => {
    updateConnectionStatus();

    const connection =
      navigator.connection ||
      navigator.mozConnection ||
      navigator.webkitConnection;

    if (connection) {
      connection.addEventListener("change", updateConnectionStatus);
    }

    return () => {
      if (connection) {
        connection.removeEventListener("change", updateConnectionStatus);
      }
    };
  }, []);

  return quality;
}
